import React from 'react'
import styled from 'styled-components'

const RecommendationCard = ({ dateLabel }) => {
  if (!dateLabel) return null

  return (
    <Card>
      <Text>
        {`Todas las especialidades que buscaste tienen disponibilidad el ${dateLabel}.`}
      </Text>
      <StrongText>Te recomendamos seleccionar esa fecha para agrupar tus consultas.</StrongText>
    </Card>
  )
}

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px 20px;
  border-radius: 10px;
  background: ${props => props.theme.colors.greys.cardBackGround};
  line-height: 1.4;
  width: 100%;
  max-width: 684px;
`

const Text = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${props => props.theme.colors.text.descriptionText};
  margin: 0;
`

const StrongText = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.theme.colors.text.primaryText};
  margin: 0;
`

export default RecommendationCard
